import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ecosystemTags } from '../../data/homeContent';

const initialForm = {
  name: '',
  email: '',
  phone: '',
  school: '',
  message: '',
};

function HomeCta() {
  const [form, setForm] = useState(initialForm);
  const [sent, setSent] = useState(false);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setSent(true);
    setForm(initialForm);
  };

  return (
    <section className="home-cta" id="demo">
      <div className="container">
        <div className="home-cta-panel">
          <div className="home-cta-copy">
            <p className="home-kicker">SEE BRIGHT STUDY IN ACTION</p>
            <h2>Ready to build a future-ready school?</h2>
            <p>
              Connected systems, AI insights, and automation that give hours back to teaching and leadership.
            </p>
            <div className="home-tags">
              {ecosystemTags.slice(0, 8).map((tag) => (
                <span key={tag}>{tag}</span>
              ))}
            </div>
            <div className="home-hero-actions">
              <Link to="/register-for-demo" className="home-btn home-btn-primary">
                Register for Demo
              </Link>
              <Link to="/contact-us/connect-with-us" className="home-btn home-btn-ghost">
                Contact sales
              </Link>
            </div>
          </div>

          <form className="home-form" onSubmit={onSubmit}>
            <h3>Get Bright Study for your school</h3>
            <p className="home-form-lead">Share a few details and we’ll set up a walkthrough for your campus.</p>
            {sent ? (
              <p className="home-form-success">Thank you. Our team will reach out shortly.</p>
            ) : (
              <>
                <input name="name" value={form.name} onChange={onChange} placeholder="Full name" required />
                <input name="email" type="email" value={form.email} onChange={onChange} placeholder="Email ID" required />
                <input name="phone" value={form.phone} onChange={onChange} placeholder="Mobile number" required />
                <input name="school" value={form.school} onChange={onChange} placeholder="School / organisation" required />
                <textarea name="message" value={form.message} onChange={onChange} placeholder="Your message" rows="3" />
                <button type="submit" className="home-btn home-btn-primary">
                  Submit
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default HomeCta;
